// RHFCheckbox.jsx

import React from "react";
import { Checkbox } from "@mantine/core";
import { Controller, useFormContext } from "react-hook-form";

const RHFCheckbox = ({
  name,
  rules,
  defaultValue = false,
  onValueChange,
  ...props
}) => {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      rules={rules}
      defaultValue={defaultValue}
      render={({ field, fieldState: { error } }) => (
        <Checkbox
          {...props}
          checked={!!field.value}
          error={error?.message}
          styles={{
            label: {
              fontSize:'16px'
            }
          }}
          onChange={(event) => {
            const checked = event.currentTarget.checked;

            field.onChange(checked);
            

            if (onValueChange) {
              onValueChange(checked);
            }
          }}
        />
      )}
    />
  );
};

export default RHFCheckbox;